import { AfterViewInit, Component, Input } from "@angular/core";
import { Fiat, Sepa, FiatWallet, Provider } from "@models";
import { UserService } from "@main-services/user.service";
import { MasterdataService } from "@core-services/masterdata.service";
import { NewProfileFacade } from "@modules/main/components/profile/new-profile/state/new-profile.facade";
import { FiatService } from "@main-services/currency";

@Component({
	selector: "sepa-qr",
	templateUrl: "./sepa-qr-tile.component.html",
	styleUrls: ["./sepa-qr-tile.component.scss"],
	standalone: false
})
export class SepaQrTileComponent implements AfterViewInit {
	public profile$ = this.profileFacade.getProfile$();

	constructor(
		private masterdataService: MasterdataService,
		private fiatService: FiatService,
		private profileFacade: NewProfileFacade,
		private userService: UserService
	) {}

	@Input()
	public wallet: FiatWallet = null;
	@Input()
	public amount: number = 0;
	@Input()
	public showNonEuInfo: boolean = true;
	@Input()
	public provider: Provider = null;
	@Input()
	public sendEmail: boolean = false;

	public ngAfterViewInit(): void {
		if (this.provider) {
			this.masterdataService.getSepaForFiatId(
				this.fiat.getId(),
				this.provider.getId(),
				this.userService.user.getId(),
				this.amount,
				this.sendEmail
			);
		}
	}

	public get qrValue(): string {
		const amount = this.amount === 0 ? "" : this.fiat.getSymbol() + this.amount;
		let value = "BCD\n001\n1\nSCT\n";
		value += this.sepa.getBic() + "\n" + this.sepa.getReceiver() + "\n" + this.sepa.getIban();
		value += "\n" + amount + "\n\n" + this.paymentReference;
		return value;
	}

	public get paymentReference(): string {
		const sepaPaymentNumber = this.sepa.getUniquePaymentNumber();
		if (sepaPaymentNumber !== "") {
			return sepaPaymentNumber;
		}
		return this.userService.user.getPaymentReference();
	}

	public get sepa(): Sepa {
		return this.masterdataService.getSepas().find((s: Sepa) => s.getId() === this.fiat.getId());
	}

	public get fiat(): Fiat {
		return this.fiatService.getItemById(this.wallet.getFiatId());
	}

	public get isGBPBankTransfer(): boolean {
		return this.sepa.isGBPBankTransfer();
	}

	// TODO: move this check to parents, so this component is not loaded unnecessarily when false
	public show(): boolean {
		return !!this.wallet && !!this.sepa;
	}
}
